// Shown while a lazily-loaded route's chunk is in flight. Every page below
// Layout is code-split (see App.jsx), so this is what fills the content area
// on a first visit to a route — nav and header stay put, since the Suspense
// boundary lives inside Layout rather than around the whole router.
//
// Deliberately matches DataTable's in-place loading state ("Loading…", muted,
// centered) rather than introducing a second loading vocabulary. It is also
// delayed: a chunk usually arrives in tens of milliseconds on a warm
// connection, and flashing a spinner for 40ms reads as a glitch. Nothing is
// rendered until SPINNER_DELAY_MS has passed, so a fast load looks instant and
// only a genuinely slow one explains itself.
import { useEffect, useState } from "react";

const SPINNER_DELAY_MS = 200;

export default function RouteFallback() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), SPINNER_DELAY_MS);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center h-40 text-ink-muted text-sm"
    >
      Loading…
    </div>
  );
}
